import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import "../styles/PublicProfile.css";
import Navbar  from "../components/Navbar.jsx";
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom"; 

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function PublicProfile() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [events, setEvents] = useState([]);
  const [loadingUser, setLoadingUser] = useState(true);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
const navigate = useNavigate();

  // Fetch user info
  useEffect(() => {
    fetch(`${API_BASE}/api/users/${id}/`)
      .then((res) => res.json())
      .then(setUser)
      .finally(() => setLoadingUser(false));
  }, [id]);

  // Fetch events (pagination)
  useEffect(() => {
    setLoadingEvents(true);
    fetch(`${API_BASE}/api/events/by-user/${id}/?page=${page}`)
      .then((res) => res.json())
      .then((data) => {
        setEvents((prev) => [...prev, ...data.results]);
        setHasMore(data.next !== null);
      })
      .finally(() => setLoadingEvents(false));
  }, [id, page]);

  const loadMore = () => setPage((p) => p + 1);

  if (loadingUser) return <div className="loader"></div>;

  if (!user) return <h3 className="text-center mt-5">Użytkownik nie istnieje</h3>;


  return (
    <div className="profile-page public-profile">
        <Navbar variant="default" />
        <div
        className="profile-cover"
        style={{
            backgroundImage: `url(${user.background_picture || "https://images.unsplash.com/photo-1503264116251-35a269479413"})`,
        }}
        />

            <div className="profile-avatar-wrap">
            <img
                src={user.profile_picture || "https://cdn-icons-png.flaticon.com/512/847/847969.png"}
                alt="Avatar"
                className="profile-avatar"
            />
        </div>

        <div className="container text-center mt-4">
            <h2 className="fw-bold mb-1">{user.username}</h2>
            <p className="text-muted small">{user.email}</p>
            <p className="bio mt-3">{user.bio || "Brak opisu."}</p>
        </div>

        <div className="container mt-5">
            <h4 className="fw-semibold mb-3">
                <i className="bi bi-calendar-event me-2"></i>
                Wydarzenia {user.username}:
            </h4>

            {events.length === 0 && !loadingEvents && (
            <div className="text-center py-5 text-muted">
            Brak wydarzeń od tego użytkownika.
            </div>
            )}

            <div className="row g-4">
                {events.map((e) => (
                    <div key={e.id} className="col-md-4 col-sm-6">
                        <div
                        className="card event-card border-0 shadow-sm"
                        role="button"
                        onClick={() => navigate(`/event/${e.id}`)}
                        >
                        <div
                            className="cover"
                            style={{
                            backgroundImage: `url(${
                                e.image ||
                                "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=1200&q=80"
                            })`,
                            }}
                        />
                        <div className="card-body">
                            <h6 className="fw-semibold">{e.name}</h6>
        
                            <div className="meta-item d-flex align-items-center">
                            <i className="bi bi-geo-alt me-1 text-primary"></i>
                            <span>{e.venue_name || "Online"}</span>
                            </div>
        
                            <p className="small text-muted">
                            <i className="bi bi-calendar-event me-1 text-primary"></i>{" "}
                            {dayjs(e.start_datetime).format("YYYY-MM-DD HH:mm") || ""}
                            </p>
                            <p>
                            {e.category_names
                                .filter((t) => t !== e.primary)
                                .map((t) => (
                                    <span key={t} className="badge bg-secondary me-1">
                                        {t}
                                    </span>
                                ))}
                            </p>
                        </div>
                        </div>
                    </div>
                ))}

            {loadingEvents &&
            [...Array(6)].map((_, i) => (
                <div key={i} className="col-md-4 col-sm-6">
                <div className="skeleton card border-0" style={{ height: 200 }} />
                </div>
            ))}
        </div>

            {hasMore && (
        <div className="text-center mt-4">
            <button className="btn btn-outline-primary rounded-pill" onClick={loadMore}>
                Załaduj więcej
            </button>
        </div>
        )}
    </div>
    </div>
    );
}  

